
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-crm-agenti',
  templateUrl: './crm-agenti.component.html',
  styleUrls: ['./crm-agenti.component.css']
})
export class CrmAgentiComponent implements OnInit {

 @Input() titolo:string; 

 service = 'crmAgentiGrid';

  constructor() { }

  ngOnInit() {
  }

}
